// extracted by mini-css-extract-plugin
export default {"max-lines":"title_max-lines__7gi+8","maxLines":"title_max-lines__7gi+8"};